/* 🤖 this file was generated by svg-to-ts */
export const matIconCalendarViewWeek: {
  name: 'calendar-view-week';
  data: string;
} = {
  name: 'calendar-view-week',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2h2.5v12H13V6zm-2 12H8.5V6H11v12zM4 6h2.5v12H4V6zm16 12h-2.5V6H20v12z"/></svg>`
};
